import React, { useEffect, useState } from "react";
import localization from "assets/localization/localization";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
const ViewUploadedDocuments = ({
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  siteRepository,
  getSiteRepository,
  getSiteRepositoryDetails,
  createSiteRepository,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputImage, setImageList] = useState([{ url: "", content: "" }]);
  const [siteTypeImage, setSiteTypeImage] = useState([
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
    { url: "", content: "" },
  ]);
  const [listData, setRepositoryData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [nonMandateArray, setNonMandateArray] = useState([
    "Snaps",
    "Others",
    "Videos",
    "BRD",
    "WPR",
    "Warranty Certificate",
  ]);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      getSiteRepository(match?.params?.site_id, 1, true);
      setIsLoading(false);
    })();
  }, []);
  const headers = ["Media", "Description", "Created On"];
  useEffect(() => {
    const tableData = ["doc_type", "description", "created_at"];
    if (
      getSiteRepositoryDetails &&
      Object.keys(getSiteRepositoryDetails).length > 0
    ) {
      setSiteTypeImage([]);
      if (getSiteRepositoryDetails?.required_document) {
        setSiteTypeImage(getSiteRepositoryDetails?.required_document);
      }
      const data = getSiteRepositoryDetails?.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) =>
            key === "doc_type" && element[key] === "png"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img
                        src={element["url"]}
                        style={{
                          width: "48px",
                          borderRadius: "16px",
                          height: "48px",
                        }}
                      />
                    </a>
                  ),
                }
              : key === "doc_type" && element[key] === "jpeg"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img
                        src={element["url"]}
                        style={{
                          width: "48px",
                          borderRadius: "16px",
                          height: "48px",
                        }}
                      />
                    </a>
                  ),
                }
              : key === "doc_type" && element[key] === "jpg"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img
                        src={element["url"]}
                        style={{
                          width: "48px",
                          borderRadius: "16px",
                          height: "48px",
                        }}
                      />
                    </a>
                  ),
                }
              : key === "doc_type" && element[key] === "doc"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img src={Images?.DocIcon} alt="" className="view-icon" />
                    </a>
                  ),
                }
              : key === "doc_type" && element[key] === "pdf"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img src={Images?.DocIcon} alt="" className="view-icon" />
                    </a>
                  ),
                }
              : key === "doc_type"
              ? {
                  [key]: (
                    <a href={element["url"]} target="_blank">
                      <img src={Images?.DocIcon} alt="" className="view-icon" />
                    </a>
                  ),
                }
              : { [key]: element[key] }
          )
        )
      );
      data && setRepositoryData(data);
      setPageCount(
        Math.ceil(
          getSiteRepositoryDetails.total / getSiteRepositoryDetails.per_page
        )
      );
    }
  }, [getSiteRepositoryDetails]);
  const onPageChange = async (val) => {
    setIsLoading(true);
    getSiteRepository(match.params.id, val.selected + 1);
    setIsLoading(false);
  };
  return (
    <Layout
      title={"Uploaded Documents List"}
      isLoading={isLoading}
      isGoback={true}
    >
      <>
        <div className="container-fluid">
          <div className="card mt-2">
            <div className="card-header">
              {'Document List'}
            </div>
            <div className="card-header">
              <div className="card-body">
                <TableSection
                  data={listData}
                  isId={false}
                  isMngId={false}
                  headers={headers}
                  pageCount={pageCount}
                  onPageChange={onPageChange}
                  onChange={() => {}}
                  detailList={listData && listData}
                  srNo={getSiteRepositoryDetails?.from}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </Layout>
  );
};
export default ViewUploadedDocuments;